
import Vue from 'vue'
import App from './App'

import router from './router/index'

import Element from 'element-ui'

import './assets/theme/index.css';

Vue.use(router)
Vue.use(Element)


new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js